import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'
import { switchProp } from 'styled-tools'
import { color } from '../../../utils/styles'

const InputAdornment = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 1em;
  color: ${color('base')};
  z-index: 4;

  ${switchProp('position', {
    start: css`
      margin-right: .5em;
    `,
    end: css`
      margin-left: .5em;
    `
  })}
`

InputAdornment.propTypes = {
  position: PropTypes.oneOf(['start', 'end'])
}

export default InputAdornment
